<template>
  <section v-scroll-nav="{ path: '/about/who' }" class="about">
    <SectionExplanation>
      <template v-slot:title>
        <div v-animate-in="{ delay: 0 }">{{ $t('about-who-title') }}</div>
      </template>
      <template v-slot:headline>
        <div v-animate-in="{ delay: 0.15 }">{{ $t('about-who-headline') }}</div>
      </template>
      <template v-slot:body>
        <div v-animate-in="{ delay: 0.25 }">{{ $t('about-who-details') }}</div>
      </template>
      <template v-slot:links>
        <CTA
          :cta="$t('about-cta-stakeholders')"
          type="line"
          size="big"
          @click.native="toggleStakeholders(true)"
          v-animate-in="{ delay: 0.75 }"
        />
      </template>
      <template v-slot:image>
        <mq-layout mq="tb+" class="tab">
          <img :src="section.who" />
        </mq-layout>
      </template>
    </SectionExplanation>
    <Aside full :active="showStakeholders" @close="toggleStakeholders(false)">
      <Stakeholders />
    </Aside>
  </section>
</template>

<script>
import SectionExplanation from '@/components/common/SectionExplanation';
import Stakeholders from '@/components/about/Stakeholders';
import Aside from '@/components/common/Aside';
import CTA from '@/components/common/CTA';

import section from '@/assets/data/about/section';

export default {
  name: 'Who',
  components: {
    SectionExplanation,
    Stakeholders,
    Aside,
    CTA
  },
  data() {
    return {
      section,
      showStakeholders: false
    };
  },
  watch: {
    $route(to) {
      if (!to.path.includes('stakeholders')) {
        this.toggleStakeholders(false, false);
      }
    }
  },
  methods: {
    toggleStakeholders(val, nav) {
      this.showStakeholders = val;
      if (val && nav !== false) this.$router.push({ path: `/about/who/stakeholders` });
      else if (nav) {
        const parent = this.$route.matched[this.$route.matched.length - 2];
        if (parent) this.$router.push(parent.path);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.about {
  /deep/ .explanation {
    background-color: $col-blue-light;
    .headline {
      color: $col-purple-light;
    }
  }
  /deep/ aside {
    .btn-close {
      svg path {
        stroke: $col-white;
      }
      transform: translateY(3px);
    }
  }
}
</style>
